import {
  ComponentRef,
  Injectable,
  Injector,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { TableComponent } from './table.component';
import { TableModel } from './model/table.model';

@Injectable()
export class TableService {
  private readonly injector = inject(Injector);

  /**
   * @description Crea una tabla definiendo sus propiedades a usar
   * @class S = es el servicio que hace referencia
   * @class D = es la interfaz de datos con los que trabaja
   * @param table Es la construcción de la tabla en si, definimos los filtros y las columnas
   * @param viewContainerRef El ng-template de referencia donde se va a insertar la tabla
   * @param service La instancia del servicio inyectado dentro del componente padre
   * @param fx La función que se ejecuta para traer los datos
   * @param selectedItem Callback para cuando se selecciona un item
   * @param selectableItems Callback para cuando se marca el check de un item
   * @param items En caso de tener los items, solo le pasamos los mismas
   * @returns Retorna la instancia de la tabla creada
   */
  addTable<S = any, D = any>(
    table: TableModel,
    viewContainerRef: ViewContainerRef,
    service?: S,
    fx?: keyof S,
    selectedItem?: (i: D) => void,
    selectableItems?: (i: D[]) => void,
    items?: D[]
  ) {
    // 1. Directly create the component without ComponentFactoryResolver
    const componentRef: ComponentRef<TableComponent<S, D>> =
      viewContainerRef.createComponent(TableComponent<S, D>, {
        injector: this.injector,
      });

    // Set instance properties
    if (!items) {
      componentRef.instance.servicio = service;
      if (fx) componentRef.instance.fx = fx;
    } else {
      componentRef.instance.data = items;
    }
    componentRef.instance.tabla = table;

    componentRef.instance.selectedItems.subscribe((data) => {
      if (selectableItems) selectableItems(data);
    });

    componentRef.instance.rowSelect.subscribe((data: D) => {
      if (selectedItem) selectedItem(data);
    });

    //! Optionally, return the component reference
    return componentRef.instance;
  }
}
